import React from 'react';
import { Point } from '@/types';
import { BooleanStatus } from '../helpers/BooleanStatus';

export type PointListItemProps = {
  point: Point;
  onClick?: (point: Point) => void;
  active?: boolean;
  children?: React.ReactNode;
};

export const PointListItem = ({
  point,
  onClick,
  // active,
  children,
}: PointListItemProps) => {
  return (
    <div key={point.id} role="button" onClick={() => onClick?.(point)}>
      <div>
        <b>#{point.id}</b> {point.name} ({point.loc_id})
      </div>
      <div className="d-flex gap-3">
        <span>Type: {point.loc_type_ind}</span>
        <span>Direction: {point.dir_flo}</span>
        <span>Receipt Zone: {point.receipt_zone_name}</span>
        <span>Delivery Zone: {point.delivery_zone_name}</span>
      </div>
      <div className="d-flex gap-3 mt-3">
        <span>{point.tsp_name}</span>
      </div>
      {children}
      <div className="text-end d-flex justify-content-end gap-3 mt-2">
        <BooleanStatus
          value={Boolean(point.node)}
          trueText="Mapped"
          falseText="Not Mapped"
        />
      </div>
      <hr />
    </div>
  );
};
